<template>
  <div>
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div id="kt_content_container"
           style="margin-top:10px;max-width:100%;flex-direction:row!important;display:flex; flex-wrap: wrap;">
        <!-- 搜索开始 -->
        <div style="width: 100%; margin-bottom: 10px;">
          <form action="#" id="pool_form1">
            <div class="card">
              <div class="card-body" style="padding: 1.2rem 1rem; display: flex;">
                <label class="el-form-item__label fw-bolder text-dark" style="width: 90px; padding-right: 7px;">商品池名称：</label>
                <div class="demo-input-suffix">
                  <el-input
                      @change="change"
                      placeholder="请输入内容"
                      prefix-icon="el-icon-search"
                      v-model.trim="poolDto.poolName"
                      clearable @clear="getPoolList">
                  </el-input>
                </div>

                <label class="el-form-item__label fw-bolder text-dark" style="width: 90px; padding-right: 7px;">商品池级别：</label>
                <div class="demo-input-suffix">
                  <el-select v-model.number="poolDto.poolLevel" clearable placeholder="请选择商品池级别" size="small">
                    <el-option :value="0" label="一级商品池"></el-option>
                    <el-option :value="1" label="二级商品池"></el-option>
                    <el-option :value="2" label="三级商品池"></el-option>
                  </el-select>
                </div>

                <label class="el-form-item__label fw-bolder text-dark" style="width: 90px; padding-right: 7px;">下载需求：</label>
                <div class="demo-input-suffix">
                  <el-select v-model.number="poolDto.need" clearable placeholder="请选择商品池级别" size="small">
                    <el-option :value="1" label="需要"></el-option>
                    <el-option :value="-1" label="舍弃"></el-option>
                  </el-select>
                </div>

                <label class="el-form-item__label fw-bolder text-dark" style="width: 90px; padding-right: 7px;">下载状态：</label>
                <div class="demo-input-suffix">
                  <el-select v-model="poolDto.downloadStatus" multiple clearable placeholder="请选择商品池级别" size="small">
                    <el-option :value="-1" label="暂未开始"></el-option>
                    <el-option :value="0" label="需要重下"></el-option>
                    <el-option :value="1" label="正在下载"></el-option>
                    <el-option :value="2" label="下载完成"></el-option>
                  </el-select>
                </div>



                <el-button style="margin-left: 10px; height: 40px;" type="primary" size="mini" @click="getPoolList"> 搜索</el-button>
                <el-button style="margin-left: 10px; height: 40px;" @click="reset" size="mini">重置</el-button>
                <el-button style="margin-left: 10px; height: 40px;" type="primary" size="mini" icon="el-icon-edit"
                           :disabled="ids.length < 1" @click="updateDialog = true">
                  批量修改状态
                </el-button>

                <el-button style="margin-left: 10px; height: 40px;" type="primary" size="mini" icon="el-icon-edit"
                           :disabled="ids.length < 1" @click="downloadDialog = true">
                  下载选中
                </el-button>

                <el-button style="margin-left: 10px; height: 40px;" type="primary" size="mini" icon="el-icon-edit"
                           @click="downloadDialog = true,ids = []">
                  下载全部
                </el-button>

                <el-button style="margin-left: 10px; height: 40px;" type="primary" size="mini" icon="el-icon-download"
                           @click="openLogViewerDialog">
                  查看日志
                </el-button>

                <el-dialog
                    title="提示"
                    :visible.sync="updateDialog"
                    width="30%">
                  <span>修改选中的下载需求</span>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="updateDialog = false">取 消</el-button>
                    <el-button type="primary" @click="updatePool(0,1,0)">需 要</el-button>
                    <el-button type="danger" @click="updatePool(0,-1,0)">舍 弃</el-button>
                  </span>
                </el-dialog>
              </div>
            </div>
          </form>
        </div>
        <!-- 列表开始 -->
        <div class="card mb-5 mb-xl-8" style="margin-left:3px;width:100%;"
             element-loading-text="拼命加载中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)"
             v-loading="loading">
          <div class="card-body py-3" style="padding-left: 15px;">
            <div class="table-responsive">
              <!-- 表格数据-->
              <el-table
                  :data="rows"
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column prop="poolId" label="商品池id" align="center" class="100">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="poolName"
                    label="商品池名称"
                    width="200"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="下载时间" width="200" align="center">
                  <template #default="{row}">
                    <div v-html="row.downloadTime"></div>
                  </template>
                </el-table-column>
                <el-table-column label="结束时间" width="200" align="center">
                  <template #default="{row}">
                    <div v-html="row.downloadEnd"></div>
                  </template>
                </el-table-column>

                <el-table-column label="下载顺序" height="100" width="120" align="center">
                  <template #default="{row}">
                    <div class="center-block text-black text-hover-info border-hover-info cursor-pointer "
                         style="border: 1px solid rgba(9, 9, 9, 0.35);padding: 3px; width: 70%; border-radius: 10px;"
                         @click="openUpdatePoolDialog(3,row.downloadSort,row.poolId)"
                         v-html="row.downloadSort"></div>
                  </template>
                </el-table-column>
                <el-table-column label="评论数限制" width="150" align="center">
                  <template #default="{row}">
                    <div class="center-block text-black text-hover-info border-hover-info cursor-pointer "
                         style="border: 1px solid rgba(9, 9, 9, 0.35);padding: 3px; width: 70%; border-radius: 10px;"
                         @click="openUpdatePoolDialog(2,row.commentLimit,row.poolId)"
                         v-html="row.commentLimit"></div>
                  </template>
                </el-table-column>
                <el-table-column label="下载需求" width="150" align="center">
                  <template #default="{row}">
                    <div class="center-block text-primary text-hover-info border-hover-info cursor-pointer "
                         style="border: 1px solid rgba(9, 9, 9, 0.35);padding: 3px; width: 70%; border-radius: 10px;"
                         v-if="row.need === 1" @click="openUpdatePoolDialog(1,-1, row.poolId)"> 需要
                    </div>
                    <div class="center-block text-danger text-hover-info border-hover-info cursor-pointer "
                         style="border: 1px solid rgba(9, 9, 9, 0.35);padding: 3px; width: 70%; border-radius: 10px;"
                         v-if="row.need === -1" @click="openUpdatePoolDialog(1,1, row.poolId)"> 舍弃
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="下载状态" width="200" align="center">
                  <template #default="{row}">
                    <div v-if="row.downloadStatus === -1">暂未开始</div>
                    <div v-if="row.downloadStatus === 0">需要重下</div>
                    <div v-if="row.downloadStatus === 1">正在下载</div>
                    <div v-if="row.downloadStatus === 2">下载完成</div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  ref="pagination"
                  style="margin-top: 10px;text-align: center"
                  @size-change="statusHandleSizeChange"
                  @current-change="statusHandleCurrentChange"
                  :current-page.sync="poolDto.current"
                  :page-sizes="[10, 20, 30, 50]"
                  :page-size="poolDto.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalCount">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        :title="poolDownload.title"
        :visible.sync="updateDownloadDialog"
        width="30%">
      <div v-if="poolDownload.type === 1">
        <span class="fs-5">点击舍弃或需要按钮修改该数据的下载需求</span>
      </div>
      <div v-if="poolDownload.type === 2">
        <span class="fw-bold fs-5">评论限制：</span>
        <el-input class="ms-2" style="width: 200px;" v-model="poolDownload.commentLimit" placeholder="请输入评论限制次数"></el-input>
      </div>
      <div v-if="poolDownload.type === 3">
        <span class="fw-bold fs-5">下载顺序：</span>
        <el-input class="ms-2" style="width: 200px;" v-model="poolDownload.downloadSort" placeholder="请输入下载顺序"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDownloadDialog = false">取 消</el-button>
        <el-button v-if="poolDownload.need === 1" type="primary" @click="updatePool(1,1)">需 要</el-button>
        <el-button v-if="poolDownload.need === -1" type="danger" @click="updatePool(1,-1)">舍 弃</el-button>
        <el-button v-if="poolDownload.type === 2" type="primary" @click="updatePool(2,poolDownload.commentLimit)">确 认</el-button>
        <el-button v-if="poolDownload.type === 3" type="primary" @click="updatePool(3,poolDownload.downloadSort)">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="将下载选中商品池的数据"
        :visible.sync="downloadDialog"
        width="30%">

      <span class="fs-5"> 是否确认下载数据</span>

      <span slot="footer" class="dialog-footer">
        <el-button @click="downloadDialog = false">取 消</el-button>
        <el-button @click="downloadDataByPool">确 认</el-button>
      </span>
    </el-dialog>

    <LogViewer ref="logViewer" v-if="logViewerVisible"/>

  </div>
</template>
<script>

import {getJdCommodityPoolListApi, updatePoolByPoolIdApi} from "@/api/backend/poolApi";
import { downloadDataByPoolApi } from "@/api/download/poolApi";
import LogViewer from "@/components/LogViewer/index.vue";


export default {
  components: {LogViewer},
  data() {
    return {
      logViewerVisible: false, // 加在组件

      rows: [],
      loading: false,
      ids: [],
      id: "",
      updateDialog: false, // 修改弹出框
      totalCount: 999,
      first: true,
      poolDto: {
        current: 1,
        size: 10,
        poolName: "",
        poolId: "",
        downloadStatus: "",
        downloadSort: "",
        need: "",
        commentLimit: "",
      },
      updateDownloadDialog: false,
      poolDownload: {
        title: "",
        type: "",
        poolIds: [],
        downloadSort: "",
        need: "",
        commentLimit: ""
      },
      downloadDialog: false, //下载数据
      downloadPool: {
        poolIds: [],
        current: 1,
        size: 10
      }
    };
  },
  // 方法
  methods: {
    /**
     * 分页大小切换时触发
     * @param val
     */
    statusHandleSizeChange(val) {
      this.poolDto.size = val;
      this.getPoolList();
    },
    /**
     * 页码切换时触发
     * @param val
     */
    statusHandleCurrentChange(val) {
      this.poolDto.current = val;
      this.getPoolList();
    },
    // 当输入框值为空值 或者改变 会执行语句或刷新 列表
    change(value) {
      if (!value) {
        this.getPoolList();
      }
    },
    async getPoolList() {
      this.loading = true;
      let config = {
        ...this.poolDto,
        downloadStatus:this.poolDto.downloadStatus ? this.poolDto.downloadStatus.join(','):''
      }
      let {data} = await getJdCommodityPoolListApi(config)
      this.loading = false;
      this.rows = data.rows;
      this.totalCount = data.total;
    },
    // 复选框 将id 组成集合
    handleSelectionChange(val) {
      let arr = []
      val.forEach(item => {
        arr.push(item.poolId)
      })
      this.ids = arr;
    },

    // 修改单个商品池下载数据的弹出框
    openUpdatePoolDialog(type, data, id) {
      this.poolDownload.type = type;
      // 1 需求 2 评论 3 顺序
      if (type === 1) {
        this.poolDownload.poolIds = [id];
        this.poolDownload.title = "修改选中数据的下载需求";
        this.poolDownload.need = data;
      } else if (type === 2) {
        this.poolDownload.poolIds = [id];
        this.poolDownload.title = "修改选中数据的评论限制";
        this.poolDownload.commentLimit = data;
      } else if (type === 3) {
        this.poolDownload.poolIds = [id];
        this.poolDownload.title = "修改选中数据的下载顺序";
        this.poolDownload.downloadSort = data;
      }
      this.updateDownloadDialog = true;
    },
    // 修改商品池是否需要参与下载的数据
    async updatePool(type, data) {
      if (type === 0) {
        // 需求的批量数据修改
        this.poolDownload.poolIds = this.ids;
        this.poolDownload.need = data;
      }
      /*// 需求的单个数据修改
      if (type === 1) {
        this.poolDownload.need = data;
      } else if (type === 0) {
        // 需求的批量数据修改
        this.poolDownload.poolIds = this.ids;
        this.poolDownload.need = data;
      } else if (type === 2) {
        this.poolDownload.commentLimit = data;
      } else if (type === 3) {
        this.poolDownload.downloadSort = data;
      }*/
      console.log(this.poolDownload)
      await updatePoolByPoolIdApi(this.poolDownload);
      this.getPoolList();
      this.updateDialog = false;
      this.poolDownload.need = "";
      this.poolDownload.commentLimit = "";
      this.poolDownload.downloadSort = "";
      this.ids = [];
      this.updateDownloadDialog = false;
    },
    // 根据商品池下载数据
    async downloadDataByPool() {
      if (this.ids) {
        let poolList = [];
        this.ids.forEach(id => {
          let poolDo = {poolId: id}; // 创建一个包含 poolId 的简单对象
          poolList.push(poolDo); // 将对象添加到 poolList 数组中
        });
        this.downloadPool.poolIds = poolList;
      }
      downloadDataByPoolApi(this.downloadPool);
      this.downloadDialog = false;
      this.$message({
        message: '下载启动成功',
        type: 'success'
      });
      this.openLogViewerDialog();
    },
    openLogViewerDialog() {
      this.logViewerVisible = true;
      // 使用 $nextTick 确保子组件已经渲染完成
      this.$nextTick(() => {
        // 通过 $refs 访问子组件并调用方法
        this.$refs.logViewer.openLogsDialog();
      });
    },
    /*重置*/
    reset() {
      this.poolDto = {
        current: 1,
        size: 10,
        poolName: "",
        poolId: "",
        poolLevel: "",
        parentId: "",
        fullName: "",
        downloadStatus: "",
        downloadSort: "",
        need: "",
        commentLimit: "",
      };
      this.getPoolList();
    },

  },

  // 初始化这个方法
  created() {
    this.getPoolList();
  },
};
</script>
<!--组件样式-->
<style scoped>

/deep/ .el-input--small .el-input__inner {
  height: 40px;
}
</style>